var _clipPath;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1000 1000",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "Artboard1",
    x: 0,
    y: 0,
    width: 1000,
    height: 1000,
    style: {
      fill: "none"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Artboard11",
    x: 0,
    y: 0,
    width: 1000,
    height: 1000
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.55412,0.344975,0.344975,1.55412,-572.766,-567.28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.963,382.845L744.03,828.912C759.741,844.622 792.53,837.344 817.205,812.668C841.881,787.993 849.159,755.204 833.448,739.493L387.382,293.426C371.671,277.715 338.882,284.994 314.206,309.669C289.531,334.345 282.252,367.134 297.963,382.845Z",
    style: {
      fill: "rgb(179,179,179)",
      stroke: "rgb(230,230,230)",
      strokeWidth: "0.53px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.01937,0,0,1.01937,-73.2394,-20.7979)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.866,979.447L1030.89,148.421C1060.16,119.151 1060.16,71.625 1030.89,42.355C1001.62,13.085 954.095,13.085 924.825,42.355L93.8,873.381C64.53,902.65 64.53,950.177 93.8,979.447C123.07,1008.72 170.596,1008.72 199.866,979.447Z",
    style: {
      fill: "rgb(179,179,179)",
      stroke: "rgb(230,230,230)",
      strokeWidth: "0.98px"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.e2b1d045598c70bd10f21662e00888cb.svg";
export { ForwardRef as ReactComponent };